import { Component, OnInit, AfterViewChecked, NgZone, OnDestroy, ChangeDetectionStrategy, Input} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ChangeDetectorRef } from '@angular/core';

import { EmbryoService } from 'src/app/Services/Embryo.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "embryo-Cart",
  templateUrl: "./Cart.component.html",
  styleUrls: ["./Cart.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartComponent implements OnInit, AfterViewChecked, OnDestroy {
 
  products: any;
  quantityArray: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  popupResponse: any;

  constructor(
    public embryoService: EmbryoService,
    private router: Router,
    translate:TranslateService
  ) {
    console.log("cart - consturctor");
  }

  ngOnInit() {
    console.log("cart - oninit");
  }

  ngOnDestroy(): void {
    console.log("cart - destroy");
   this.embryoService.updateAllLocalCartProduct(
     this.embryoService.localStorageCartProductsBehaviour.value
   );
 }
  ngAfterViewChecked(): void {
    console.log("cart - afterviewchecked");
    //this.cdRef.detectChanges();
  }

  public removeProduct(value: any) {
    console.log("cart - removeproduct");
    let message = "Are you sure you want to delete this product?";
    this.embryoService.confirmationPopup(message).subscribe(
      res => {
        console.log("cart - confirmationPopup");
        this.popupResponse = res;
      },
      err => console.log(err),
      () => this.getPopupResponse(this.popupResponse, value)
    );
  }

  public getPopupResponse(response, value) {
    console.log("cart - getPopupResponse");
    if (response) {
      this.embryoService.removeLocalCartProduct(value);
    }
  }

  public calculateProductSinglePrice(product: any, value: any) {
    console.log("cart - calculateProductSinglePrice");
    let price = 0;
    product.quantity = value;
    price = product.discount_price * value;
    return price;
  }

  public calculateTotalPrice() {
    console.log("cart - calculateTotalPrice");
    let subtotal = 0;
    if (
      this.embryoService.localStorageCartProductsBehaviour.value &&
      this.embryoService.localStorageCartProductsBehaviour.value.length > 0
    ) {
      for (let product of this.embryoService.localStorageCartProductsBehaviour.value) {
        console.log("cart - calculateTotalPrice-  loop for localStorageCartProducts");
        subtotal += product.discount_price * product.quantity;
      }
      return subtotal;
    }
    return subtotal;
  }

  public getTotalPrice() {
    return this.embryoService.getTotalPrice();
    // console.log("cart - getTotalPrice-  loop for localStorageCartProducts");
    // let total = 0;
    // if (
    //   this.embryoService.localStorageCartProductsBehaviour.value &&
    //   this.embryoService.localStorageCartProductsBehaviour.value.length > 0
    // ) {
    //   for (let product of this.embryoService.localStorageCartProductsBehaviour.value) {
    //     console.log("cart - getTotalPrice-  loop for localStorageCartProducts");
    //     total += product.discount_price * product.quantity;
    //   }
    //   total += this.embryoService.shipping + this.embryoService.tax;
    //   return total;
    // }

    // return total;
  }
  
  public updateLocalCartProduct() {
    console.log("cart - updateLocalCartProduct");
    this.embryoService.updateAllLocalCartProduct(
      this.embryoService.localStorageCartProductsBehaviour.value
    );
    this.router.navigateByUrl("checkout/payment");
  }

  public getQuantityValue(product) {
    console.log("cart - getQuantityValue");
    if (product.quantity) {
      return product.quantity;
    } else {
      return 1;
    }
  }
}
